import script from "./UnpaidList.vue?vue&type=script&lang=ts&setup=true"
export * from "./UnpaidList.vue?vue&type=script&lang=ts&setup=true"

import "./UnpaidList.vue?vue&type=style&index=0&id=37ec9eea&scoped=true&lang=css"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37ec9eea"]])

export default __exports__